import React, { Component } from 'react';
import { actions as authActions } from '~/redux/auth';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';

export class LogoutPage extends Component {
  componentDidMount() {
    this.props.logout();
  }

  render() {
    return <Redirect to='/login' />;
  }
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    logout: authActions.logout
   }, dispatch);
}

export default connect(() => ({}), mapDispatchToProps)(LogoutPage);



// WEBPACK FOOTER //
// ./src/pages/logout/logout.jsx